import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AppMobile from "./AppMobile";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("trp-root") as HTMLElement;

// Check if mobile layout is requested via data-layout attribute
// Usage: [transit_route_planner layout="mobile"] or [transit_route_planner layout="auto"]
const layoutAttr = rootElement?.getAttribute("data-layout") || "auto";

// Auto-detect mobile devices
const isMobileDevice = (): boolean => {
  // Check screen width (< 768px is typically mobile/tablet portrait)
  const isSmallScreen = window.innerWidth < 768;

  // Check user agent for mobile devices
  const mobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  // Check for touch capability as additional signal
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Use mobile layout if small screen OR (mobile user agent AND touch device)
  return isSmallScreen || (mobileUserAgent && hasTouch);
};

// Determine which layout to use
const shouldUseMobileLayout = (): boolean => {
  if (layoutAttr === "mobile") return true;
  if (layoutAttr === "default") return false;
  // "auto" or unset: detect automatically
  return isMobileDevice();
};

const mobileLayout = shouldUseMobileLayout();

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {mobileLayout ? <AppMobile /> : <App />}
  </React.StrictMode>
);

reportWebVitals();
